import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Text, Margin } from 'shared/components'

import { BinaryBetForm } from './components/binaryBetForm'
import * as styles from './styles'

const BinaryBetModalComponent = ({
  event,
  opened,
  children,
  onTrigger,
  onBetProxy,
  onInWinnableProxy,
  onRequestClose,
}) => {
  // Detect if this is a custom event or an event without teams
  const isCustomEvent = event?.sportType === 'athletics' || event?.sportType === 'other'
  const hasEmptyTeamNames = (!event?.teamA || event?.teamA === '') && (!event?.teamB || event?.teamB === '')
  const hasNoTeamObjects = !event?.teamOne && !event?.teamTwo

  // Determine if this is a custom event without teams
  const isCustomEventWithoutTeams = (isCustomEvent || hasEmptyTeamNames || hasNoTeamObjects)

  return (
    <>
      <Modal
        isOpen={opened}
        onRequestClose={onRequestClose}
        style={styles.dialogStyles}
      >
        <div css={styles.header}>
          <Button plain onClick={onRequestClose}>
            <FontAwesomeIcon icon="times" />
          </Button>
        </div>

        {isCustomEventWithoutTeams ? (
          <>
            {/* Direct text header with much higher position */}
            <div style={{ textAlign: 'left', marginTop: '-30px', marginBottom: '10px' }}>
              <Text as="h2" bold style={{ fontSize: '18px' }}>
                Event:
              </Text>
            </div>
            <BinaryBetForm
              initialValues={event}
              onSubmit={onBetProxy}
              onInWinnableProxy={onInWinnableProxy}
              onCancel={onRequestClose}
              isCustomEvent={isCustomEventWithoutTeams}
            />
          </>
        ) : (
          <Margin bottom={4}>
            <Text as="h2" size={22} bold>
              Choose the winner.
            </Text>
            <BinaryBetForm
              initialValues={event}
              onSubmit={onBetProxy}
              onInWinnableProxy={onInWinnableProxy}
              onCancel={onRequestClose}
              isCustomEvent={isCustomEventWithoutTeams}
            />
          </Margin>
        )}
      </Modal>
      {children(onTrigger)}
    </>
  )
}

BinaryBetModalComponent.propTypes = {
  event: PropTypes.shape(),
  opened: PropTypes.bool.isRequired,
  children: PropTypes.func.isRequired,
  onTrigger: PropTypes.func.isRequired,
  onBetProxy: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onInWinnableProxy: PropTypes.func.isRequired,
}

export default BinaryBetModalComponent
